import React, { useState } from 'react';
import { ChevronDown, Facebook } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const openModal = (modal: 'privacy' | 'terms') => (e: React.MouseEvent) => {
    e.preventDefault();
    setActiveModal(modal);
  };
  return <>
      <footer className="bg-text text-white py-16" data-id="element-35">
        <div className="max-w-6xl mx-auto px-4" data-id="element-36">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-37">
            {/* Left */}
            <div className="space-y-4" data-id="element-38">
              <img src="https://cdn.magicpatterns.com/uploads/vy6YPCN3kE63ZKxWgSB7L5/ChatGPT_Image_24_may_2026,_10_51_37_p.m..png" alt="El Código del Bienestar" style={{
              width: '240px',
              height: 'auto',
              filter: 'brightness(0) invert(1)'
            }} className="block border-0 outline-none max-w-full" data-id="element-39" />
              <p className="text-accent italic opacity-90 max-w-xs" data-id="element-40">
                Tu cuerpo tiene un código.
                <br data-id="element-41" />
                Aquí te ayudamos a descifrarlo.
              </p>
            </div>

            {/* Center */}
            <div data-id="element-42">
              <h3 className="font-bold text-lg mb-4 text-white" data-id="element-43">Legal</h3>
              <div className="space-y-2" data-id="element-44">
                <button className="flex items-center gap-2 text-accent hover:text-accent/80 transition-colors focus:outline-none" onClick={() => setLegalOpen(!legalOpen)} data-id="element-45">
                  <span data-id="element-46">Documentos legales</span>
                  <ChevronDown className={`w-4 h-4 transition-transform ${legalOpen ? 'rotate-180' : ''}`} data-id="element-47" />
                </button>

                <div className={`pl-4 space-y-2 border-l border-white/20 overflow-hidden transition-all duration-300 ${legalOpen ? 'max-h-24 pt-2 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-48">
                  <button onClick={openModal('privacy')} className="block text-left text-sm text-accent hover:text-white transition-colors focus:outline-none" data-id="element-49">
                    Política de Privacidad
                  </button>
                  <button onClick={openModal('terms')} className="block text-left text-sm text-accent hover:text-white transition-colors focus:outline-none" data-id="element-50">
                    Términos y Condiciones
                  </button>
                </div>
              </div>
            </div>

            {/* Right */}
            <div data-id="element-51">
              <h3 className="font-bold text-lg mb-4 text-white" data-id="element-52">Síguenos</h3>
              <a href="#" className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors" data-id="element-53">
                <Facebook className="w-5 h-5 text-accent" data-id="element-54" />
                <span data-id="element-55">@ElCódigoDelBienestar</span>
              </a>
            </div>
          </div>

          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-accent" data-id="element-56">
            <p data-id="element-57">© 2026 El Código del Bienestar.</p>
            <p data-id="element-58">⚕️ Contenido informativo. No reemplaza consejo médico.</p>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-59">
        <p className="text-sm text-gray italic" data-id="element-60">
          Última actualización: 1 de enero de 2026
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-61">
          1. Información que recopilamos
        </h3>
        <p data-id="element-62">
          En <strong data-id="element-63">El Código del Bienestar</strong> recopilamos la información
          mínima necesaria para procesar tu compra y entregarte el e-book: tu
          nombre, dirección de correo electrónico y datos de pago (procesados de
          forma segura por nuestros proveedores certificados).
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-64">
          2. Uso de la información
        </h3>
        <p data-id="element-65">
          Usamos tus datos exclusivamente para: (a) enviarte el enlace de
          descarga del e-book, (b) brindar soporte si lo solicitas, y (c)
          enviarte ocasionalmente contenido relacionado con bienestar y sueño.
          Puedes darte de baja en cualquier momento desde cualquier correo que
          recibas.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-66">
          3. Protección de datos
        </h3>
        <p data-id="element-67">
          Tus datos se almacenan en servidores seguros con cifrado estándar de
          la industria. Nunca vendemos, alquilamos ni compartimos tu información
          personal con terceros con fines comerciales.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-68">
          4. Cookies
        </h3>
        <p data-id="element-69">
          Utilizamos cookies esenciales para el funcionamiento del sitio y
          cookies analíticas anónimas para mejorar la experiencia. No usamos
          cookies de publicidad invasivas.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-70">
          5. Tus derechos
        </h3>
        <p data-id="element-71">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Para ejercer estos derechos, escríbenos a{' '}
          <strong data-id="element-72">contacto@elcodigodelbienestar.com</strong>.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-73">
          6. Contacto
        </h3>
        <p data-id="element-74">
          Si tienes preguntas sobre esta política, contáctanos a través de
          nuestro correo oficial. Responderemos en un máximo de 72 horas
          hábiles.
        </p>
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-75">
        <p className="text-sm text-gray italic" data-id="element-76">
          Última actualización: 1 de enero de 2026
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-77">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-78">
          Al adquirir <strong data-id="element-79">El Código del Sueño Profundo</strong>, aceptas
          estos términos y condiciones. Si no estás de acuerdo, te pedimos que
          no realices la compra.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-80">
          2. Naturaleza del producto
        </h3>
        <p data-id="element-81">
          El producto es un e-book digital en formato PDF entregado por descarga
          inmediata tras el pago. No es un producto físico y no se envía por
          correo postal.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-82">
          3. Pago y entrega
        </h3>
        <p data-id="element-83">
          El pago se procesa de forma segura a través de pasarelas certificadas.
          Una vez confirmado el pago, recibirás un correo con el enlace de
          descarga en cuestión de minutos. Si no lo recibes, revisa tu carpeta
          de spam o contáctanos.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-84">
          4. Política de reembolso
        </h3>
        <p data-id="element-85">
          Por tratarse de un producto digital de descarga inmediata, los
          reembolsos están sujetos a evaluación caso por caso. Si tienes algún
          problema con tu compra, escríbenos dentro de los 7 días siguientes a
          la compra y haremos lo posible por resolverlo.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-86">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-87">
          Todo el contenido del e-book es propiedad de El Código del Bienestar.
          Está prohibida su reproducción, distribución o reventa total o parcial
          sin autorización escrita.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-88">
          6. Aviso médico
        </h3>
        <p data-id="element-89">
          ⚕️ El contenido del e-book es informativo y educativo. No reemplaza el
          consejo, diagnóstico ni tratamiento médico profesional. Si tienes una
          condición médica, consulta siempre con un profesional de la salud
          antes de aplicar cualquier protocolo.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-90">
          7. Limitación de responsabilidad
        </h3>
        <p data-id="element-91">
          Los resultados pueden variar según cada persona. No garantizamos
          resultados específicos. El usuario es responsable de aplicar las
          recomendaciones con criterio y responsabilidad.
        </p>

        <h3 className="font-serif text-lg font-bold text-primary mt-4" data-id="element-92">
          8. Contacto
        </h3>
        <p data-id="element-93">
          Para cualquier consulta legal o sobre tu compra, escríbenos a{' '}
          <strong data-id="element-94">contacto@elcodigodelbienestar.com</strong>.
        </p>
      </LegalModal>
    </>;
}